module.exports = __webpack_public_path__ + "static/media/f01_4.54f6488b.png";